// This file was auto-generated by Fern from our API Definition.
import { normalizeClientOptionsWithAuth } from "../../../../BaseClient.js";
import { mergeHeaders } from "../../../../core/headers.js";
import * as core from "../../../../core/index.js";
import * as environments from "../../../../environments.js";
import { handleNonStatusCodeError } from "../../../../errors/handleNonStatusCodeError.js";
import * as errors from "../../../../errors/index.js";
import * as AgentaApi from "../../../index.js";
/**
 * Manage projects within a workspace.
 */
export class ProjectsClient {
    _options;
    constructor(options) {
        this._options = normalizeClientOptionsWithAuth(options);
    }
    /**
     * @param {ProjectsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.projects.getProjects()
     */
    getProjects(requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__getProjects(requestOptions));
    }
    async __getProjects(requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "projects"),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            throw new errors.AgentaApiError({
                statusCode: _response.error.statusCode,
                body: _response.error.body,
                rawResponse: _response.rawResponse,
            });
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/projects");
    }
    /**
     * @param {AgentaApi.CreateProjectRequest} request
     * @param {ProjectsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.projects.createProject({
     *         name: "name"
     *     })
     */
    createProject(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__createProject(request, requestOptions));
    }
    async __createProject(request, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "projects"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/projects");
    }
    /**
     * @param {AgentaApi.GetProjectRequest} request
     * @param {ProjectsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.projects.getProject({
     *         project_id: "project_id"
     *     })
     */
    getProject(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__getProject(request, requestOptions));
    }
    async __getProject(request, requestOptions) {
        const { project_id: projectId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `projects/${core.url.encodePathParam(projectId)}`),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/projects/{project_id}");
    }
    /**
     * @param {AgentaApi.DeleteProjectRequest} request
     * @param {ProjectsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.projects.deleteProject({
     *         project_id: "project_id"
     *     })
     */
    deleteProject(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__deleteProject(request, requestOptions));
    }
    async __deleteProject(request, requestOptions) {
        const { project_id: projectId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `projects/${core.url.encodePathParam(projectId)}`),
            method: "DELETE",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "DELETE", "/projects/{project_id}");
    }
    /**
     * @param {AgentaApi.UpdateProjectRequest} request
     * @param {ProjectsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.projects.updateProject({
     *         project_id: "project_id"
     *     })
     */
    updateProject(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__updateProject(request, requestOptions));
    }
    async __updateProject(request, requestOptions) {
        const { project_id: projectId, ..._body } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `projects/${core.url.encodePathParam(projectId)}`),
            method: "PATCH",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: _body,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "PATCH", "/projects/{project_id}");
    }
}
